var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M417.706,256.15c0,89.177-72.4,161.706-161.706,161.706S94.294,345.327,94.294,256.15  c0-89.435,72.4-161.835,161.706-161.835S417.706,166.716,417.706,256.15L417.706,256.15z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2DD30"
    },
    d: "M133.009,215.497h93.954l21.26-65.429l5.646,17.55l-30.874,95.114l-9.198-6.71l9.617-29.553h-75.562   L133.009,215.497z M179.953,360.168l29.037-89.306l-55.653-40.525h18.356l80.888,58.722l-9.195,6.71l-25.198-18.326l-23.391,72.013   L179.953,360.168L179.953,360.168z M332.044,360.168L256,304.935l-55.623,40.393l5.679-17.292l80.821-58.851l3.453,10.84   l-25.135,18.197l61.141,44.526L332.044,360.168L332.044,360.168z M378.988,215.497l-75.981,55.365l21.263,65.432l-14.841-10.843   l-30.845-95.114h11.292l9.614,29.685l61.174-44.526L378.988,215.497L378.988,215.497z M256,126.191l29.037,89.306h68.819   l-14.874,10.972h-99.954l3.519-10.972h31.165l-23.391-71.885L256,126.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2DD30"
    },
    d: "M258.709,385.465h-5.389v-70.077h5.389V385.465L258.709,385.465z M378.182,298.479l-66.625-21.551   l1.678-5.032l66.658,21.551L378.182,298.479L378.182,298.479z M133.785,298.479l-1.678-5.032l66.688-21.551l1.649,5.032   L133.785,298.479L133.785,298.479z M293.072,209.689l-4.391-3.096l41.202-56.657l4.292,3.099L293.072,209.689L293.072,209.689z    M219.027,209.689l-41.268-56.654l4.358-3.099l41.169,56.657L219.027,209.689L219.027,209.689z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.913433682d903b6a5c52ce471d97d349.svg";
export { ForwardRef as ReactComponent };